// extracted by mini-css-extract-plugin
export default {"plain":"mobileScrollContainer_plain__eS7tG","withBottomNav":"mobileScrollContainer_withBottomNav__LGhrR"};